import { render } from "./ConfirmCode.vue?vue&type=template&id=25b23f72"
import script from "./ConfirmCode.vue?vue&type=script&lang=js"
export * from "./ConfirmCode.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__